import { getMapInfrastructure } from '../api/get_infrastructure';
export function searchMapInfrastructureAction(bbox) {
  return function (dispatch, getState, _ref) {
    var httpApi = _ref.httpApi,
      logger = _ref.logger;
    getMapInfrastructure(httpApi, bbox, logger)
    // @ts-ignore TS не понимает, что енумы категории сгенерированного типа и внутреннего типа одинаковые.
    .then(function (response) {
      dispatch({
        infrastructureList: response.infrastructure,
        type: 'ISetInfrastructureListAction'
      });
    }).catch(function () {
      dispatch({
        infrastructureList: [],
        type: 'ISetInfrastructureListAction'
      });
    });
  };
}
export function toggleSelectedInfrastructureTypeAction(type) {
  return {
    infrastructureType: type,
    type: 'IToggleSelectedInfrastructureTypeAction'
  };
}
export function clearSelectedInfrastructureTypesAction() {
  return {
    type: 'IClearSelectedInfrastructureTypesAction'
  };
}
export function setRulerActiveAction(isActive) {
  return {
    isRulerActive: isActive,
    type: 'ISetRulerActiveAction'
  };
}
export function setPanoramaActiveAction(isActive) {
  return {
    isActive: isActive,
    type: 'ISetPanoramaActiveAction'
  };
}
export function setNoPanoramaAction(state) {
  return {
    state: state,
    type: 'ISetNoPanoramaAction'
  };
}